export var SideEditOptions;
(function (SideEditOptions) {
    SideEditOptions["Text"] = "text";
    SideEditOptions["Select"] = "select";
    SideEditOptions["Image"] = "image";
    SideEditOptions["BackgroundImage"] = "backgroundImage";
    SideEditOptions["TextColor"] = "textColor";
    SideEditOptions["BackgroundColor"] = "backgroundColor";
    SideEditOptions["Menu"] = "menu";
    SideEditOptions["Class"] = "class";
    SideEditOptions["Repeat"] = "repeat";
    SideEditOptions["Multiple"] = "multiple";
    SideEditOptions["Link"] = "link";
    SideEditOptions["Form"] = "form";
    SideEditOptions["Repeatable"] = "repeatable";
})(SideEditOptions || (SideEditOptions = {}));
export var SideEditPropType;
(function (SideEditPropType) {
    SideEditPropType["Text"] = "text";
    SideEditPropType["Select"] = "select";
    SideEditPropType["Image"] = "image";
    SideEditPropType["Color"] = "color";
    SideEditPropType["Menu"] = "menu";
    SideEditPropType["Class"] = "class";
    SideEditPropType["Repeat"] = "repeat";
    SideEditPropType["Multiple"] = "multiple";
    SideEditPropType["Link"] = "link";
    SideEditPropType["Form"] = "form";
})(SideEditPropType || (SideEditPropType = {}));
//# sourceMappingURL=elements.js.map